module.exports = __webpack_public_path__ + "img/img21.2ac5d7ee.png";